import React from 'react'
import {Row,Col} from 'react-bootstrap'


const KonkursArchiwum  = (props) => {

        return(   
                <Row className="konkurs">
                  <Col xs={5}>
                        <Row>
                         <Col xs={3} className="wyroznienie_opis">Ogłoszenie o nr</Col>
                         <Col xs={3} className="wyroznienie_opis">Z dnia</Col>
                         <Col xs={3} className="wyroznienie_opis">Na stanowisko</Col>
                         <Col xs={3} className="wyroznienie_opis">Jednostka</Col>  
                        </Row>
                        <Row>
                        <Col xs={3}><span className="wyroznienie_arch">{props.konkurs.nr_ogloszenia}</span></Col>
                        <Col xs={3}><span className="wyroznienie_arch">{props.konkurs.data_konkurs}</span></Col>
                        <Col xs={3}><span className="wyroznienie_arch">{props.konkurs.nazwa_stanowiska}</span></Col>
                        <Col xs={3}> <span className="wyroznienie_arch">{props.konkurs.jednostka}</span></Col>  
                        </Row>
                   </Col>
                   <Col xs={5}><span className="wyroznienie_arch">Zakończona Procedura Konkursowa</span></Col>
                  <Col xs={2}><button className='btn btn-primary btn-ms' id={props.konkurs.id_konkursu}  onClick={props.wynik}>Wynik</button></Col>
                </Row>
        )
}

export default KonkursArchiwum